import React from 'react';

import clsx from 'clsx';

export const TileBody = ({ children, classModifier = null }) => (
  <div className={clsx('tile__body', classModifier && classModifier)}>{children}</div>
);
